module.exports = __webpack_public_path__ + "static/media/light-bulb.f5861abc.svg";